import {call, put, select} from "redux-saga/effects";
import {trackError} from "../../store/log/actions";
import {LogLevel} from "../../store/log/types";
import {createShortcut} from "../../store/player/actions";
import {IApplicationState} from "../../store";
import { SDK } from "../../sdk";

let alreadyRequested = false;

export default function* tryCreateShortcut() {
    if (!SDK.instance.supports.createShortcut)
        return;

    if (alreadyRequested)
        return;

    alreadyRequested = true;

    const shortcutCreated = yield select(({ player }: IApplicationState) => player.settings.shortcutCreated);
    if (shortcutCreated)
        return;

    try {
        yield put(createShortcut.request());

        yield call([SDK.instance, SDK.instance.createShortcut]);

        yield put(createShortcut.success());
    }
    catch (error) {
        yield put(createShortcut.failure());

        yield put(trackError({
            logLevel: LogLevel.Warn,
            category: "TryCreateShortcut",
            message: "Create shortcut failed",
            error: error,
        }));
    }
}